<template>
  <div>
      <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
      <v-row dense>
        <v-col>
          <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
          </v-card>
           <p></p>
            <center>
                <v-card-text>
                  <p class="text-h5 text--primary">เข้าร่วม<br>โครงการ Work From Home</p>
                  <div class="text--primary" v-if="e1==1">
                   พนักงานที่มีความประสงค์เข้าร่วมโครงการ<br>
                   Work From Home จะต้องปฏิบัติตามรายละเอียด<br>
                   ที่บริษัทกำหนดอย่างเคร่งครัด ดังต่อไปนี้<br>
                  </div>
                </v-card-text>
             </center>
              <v-card-text v-if="e1==1">
                  <p class="text-h5 text--primary">สิ่งที่ต้องมี</p>
                  <div class="text--primary">
                   1.ข้อมูลสำคัญที่ใช้ในการปฏิบัติงาน<br>
                   2.คอมพิวเตอร์ส่วนตัว / แท็บเล็ต (PC/ Notebook / Tablet) พร้อมโปรแกรมพื้นฐานที่จำเป็นต่องาน<br>
                   3.มีอินเตอร์เน็ตพร้อมใช้สำหรับการทำงาน<br>
                   4.ติดตั้งแอปพลิเคชั่นบน คอมพิวเตอร์ส่วนตัว / แท็บเล็ตเพื่อ ประชุม<br>
                  </div>
                </v-card-text>
              <v-divider class="mx-4" v-if="e1==1"></v-divider>
              <v-card-text v-if="e1==1">
                  <p class="text-h5 text--primary">เงื่อนไขและข้อกำหนด</p>
                  <div class="text--primary">
                   1.คุณจะต้องพร้อมปฏิบัติงานตลอดเวลาทำงาน ช่วงเวลาปฏิบัติงาน<br>
                   2.คุณจะต้องพร้อมประชุม หรือติดต่องานภายในเวลา 30 นาทีเมื่อมีการร้องขอ<br>
                   3.คุณจะต้องลงบันทึกเวลาปฏิบัติงานผ่านระบบ LINE Official Account - HRM-Betask<br>
                   4.หากคุณไม่ลงบันทึกเวลาปฏิบัติงานตามช่วงเวลาทำงานของคุณ ระบบจะบันทึกว่าเป็น "ขาดงาน" โดยอัตโนมัติ<br>
                   5.ขอความร่วมมือให้คุณหลีกเลี่ยงการสัมผัสใกล้ชิดกับบุคคลที่มีความเสี่ยงต่อโรค Covid-19 หรือเดือนทางในพื้นที่เสี่ยง<br>
                   6.หากมีการตรวจสอบพว่าคุณไม่ปฏิบัติตามเงื่อนไข ข้อตกลงดังกล่าว ทางบริษัท จะมีการพิจารณาบทลงโทษและมีผลต่อการพิจารณาประเมินผลงานของคุณ<br>
                  </div>
                </v-card-text>
                 <center v-if="dataReady">
                  <v-btn color="blue" block dark large  @click="accept()" v-if="e1==1 && !dataNotIsEmpty"> ฉันเข้าใจและยอมเงื่อนไข </v-btn>
                 </center>
                 <center v-if="dataReady">
                  <v-btn color="gray" block dark large  v-if="dataNotIsEmpty"> ท่านได้ลงทะเบียนเรียบร้อยแล้ว </v-btn>
                 </center>
                  <div v-if="!dataReady" class="text-center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                <template v-if="dataReady">
                 <v-card-text  v-if="e1==2" >
                  <p class="text-h6 text--primary">โปรดตรวจสอบรายละเอียดให้ครบถ้วน</p>
                  <div class="text--primary">
                   คุณจะต้อง ลงทะเบียนพื้นที่ บริเวณทำงานหรือใกล้เคียง ณ ปัจจุบัน เท่านั้น<br><br>
                  </div>
                    <GmapMap
                      :center="center"
                      :zoom="19"
                      style="width: 100%; height: 400px"
                    >
                      <GmapMarker :position="center" />
                    </GmapMap>
                  <v-simple-table
                >
                    <template v-slot:default>
                    <thead >
                        <tr>
                        <th style="background-color: #1B437C;" class="text-center">
                            ข้อมูล
                        </th>
                        <th style="background-color: #1B437C;" class="text-center">
                            รายละเอียด
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                        <td>รหัสพนักงาน</td>
                        <td>{{ profile.empCode }}</td>
                        </tr>
                        <tr>
                        <td>ชื่อ นามสกุล</td>
                        <td>{{ profile.empFull_NameTH }}</td>
                        </tr>
                        <tr>
                        <td>เบอร์โทร</td>
                        <td>{{ profile.empTel }}</td>
                        </tr>
                        <tr>
                        <td>อีเมล</td>
                        <td>{{ profile.empEmail }}</td>
                        </tr>
                        <tr>
                        <td>ตำแหน่ง</td>
                        <td>{{ profile.positionName }}</td>
                        </tr>
                        <tr>
                        <td>แผนก</td>
                        <td>{{ profile.masDepartmentName }}</td>
                        </tr>
                        <tr>
                        <td>สาขา</td>
                        <td>{{ profile.masBranchName }}</td>
                        </tr>
                        <tr>
                        <td>บริษัท</td>
                        <td>{{ profile.masCompanyName }}</td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>

                </v-card-text>
                <center>
                  <v-btn color="blue" block dark large  @click="approve()" v-if="e1==2"> ยืนยัน </v-btn>
                 </center>
                </template>

          </v-col>
        </v-row>
      </v-container>
      </center>
  </div>
</template>
<script>
import { gmapApi } from 'vue2-google-maps'
import axios from 'axios'
// import VuetifyLogo from '../logo'
export default {
  components: {
    gmapApi
  },
  name: 'Info',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      e1: 1,
      center: {},
      profile: [],
      checkItem: [],
      shifttem: [],
      form: {
        userLineuserId: '',
        userLinepictureUrl: ''
      },
      hideInfo: true,
      dataReady: true,
      hideCheckinHistory: false,
      dataNotIsEmpty: false,
      AccessKey: '',
      ApplicationKey: '',
      imageHeadHRM: '',
      imageUrlBack: '',
      infoRegister: ''
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.dataReady = false
    console.log('get_profile')
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    await this.geolocate()
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.infoRegister = JSON.parse(localStorage.getItem('liff_ch_register_wfh'))
    this.dataReady = true
    console.log(this.infoRegister)
    if (this.infoRegister) {
      this.dataNotIsEmpty = true
    }
    // await this.checkLiffLogin()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    geolocate () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.dataReady = true
          console.log('center : ', center)
          this.center = center
        },
        (error) => {
          console.log('error map :', error.message)
          alert('กรุณาเปิด location ของท่าน')
        }
      )
    },
    // async checkLiffLogin () {
    //   await this.$liff.ready.then(async () => {
    //     if (process.env.NODE_ENV === 'development') {
    //       this.getProfile_dev()
    //     } else {
    //       if (!this.$liff.isLoggedIn()) {
    //         this.$liff.login({ redirectUri: window.location })
    //       } else {
    //         await this.getProfile()
    //       }
    //     }
    //   })
    // },
    // async getProfile () {
    //   let _this = this
    //   await this.$liff
    //     .getProfile()
    //     .then(async (profileLine) => {
    //       _this.form.userLineuserId = profileLine.userId
    //       _this.form.userLinepictureUrl = profileLine.pictureUrl
    //       await _this.getDataEmp(_this.form)
    //     })
    //     .catch(function (error) {
    //       alert('Error getting profile: ' + error)
    //     })
    // },
    // async getProfile_dev () {
    //   let _this = this
    //   _this.form.userLineuserId = _this.main_profile.userLineuserId
    //   _this.form.userLinepictureUrl = _this.main_profile.pictureUrl
    //   await _this.getDataEmp(_this.form)
    // },
    // async getDataEmp (dt) {
    //   var data = JSON.parse(localStorage.getItem('liff_info'))
    //   await axios
    //     .get(
    //       // eslint-disable-next-line quotes
    //       this.DNS_IP +
    //         '/system_user/lineid?userLineuserId=' +
    //         data.userLineuserId
    //     )
    //     .then(async (response) => {
    //       if (response.data[0].empCode) {
    //         this.profile = response.data[0]
    //         //
    //       } else {
    //         this.$swal('ไม่พบรหัสพนักงาน', 'คุณไม่มีสิทธิ์เข้าใช้ระบบ กรุณาติดต่อฝ่ายบุคคล', 'error')
    //       }
    //     })
    //     // eslint-disable-next-line handle-callback-err
    //     .catch((error) => {
    //       this.$router.push('/Liff/LoginRisk')
    //     })
    // },
    accept () {
      this.e1 = 2
    },
    approve () {
      console.log('center', this.center)
      console.log('profile', this.profile)
      let ds = {
        empCode: this.profile.empCode,
        regWFHLat: this.center.lat,
        regWFHLong: this.center.lng,
        regWFHStatus: 'Approve',
        regWFHMapUrl: (this.center.lat) ? `https://www.google.co.th/maps/search/${this.center.lat},${this.center.lng}/@${this.center.lat},${this.center.lng},17z` : null //
      }
      this.addData(ds)
    },
    async addData (ds) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/ch_register_wfh/add", ds
        )
        .then(async (response) => {
          console.log(response)
          this.$router.push('/Liff/Home')
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    }

  }
}
</script>
<style scoped>
.table-header {
    background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/RegisterWFH.vue